import { mapState } from 'vuex';
import moment from 'moment';
import { getTimeArrayFromRangeKey } from './pickerParseRangeValues';
export default {
  name: 'CoreDateTimePickerFlatTextbased',
  props: {
    from: {
      type: Number,
      default: null,
      required: false
    },
    to: {
      type: Number,
      default: null,
      required: false
    },
    allowNull: {
      type: Boolean,
      default: false,
      required: false
    },
    dense: {
      type: Boolean,
      default: false,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    isRange: {
      type: Boolean,
      default: false,
      required: false
    },
    initialRange: {
      type: String,
      default: 'now-10m'
    },
    plainDates: {
      type: Boolean,
      default: false,
      required: false
    },
    dateOnly: {
      type: Boolean,
      default: false,
      required: false
    },
    futureRange: {
      type: Boolean,
      default: false,
      required: false
    },
    defaultExpand: {
      type: Boolean,
      default: false,
      required: false
    },
    hideBorderOnCollapse: {
      type: Boolean,
      default: false,
      required: false
    },
    alternateInitialText: {
      type: String,
      default: '',
      required: false
    }
  },
  data: function () {
    return {
      expanded: [],
      menu: false,
      hideAlternateText: false,
      startDate: null,
      endDate: null,
      pickedDisplayText: null
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color']),
    mathOp() {
      return this.futureRange ? '+' : '-';
    },
    expansionPanelsClass() {
      return this.hideBorderOnCollapse ? '' : 'kpi-card-text-01';
    },
    displayText() {
      if (this.alternateInitialText !== '' && !this.hideAlternateText) {
        return this.alternateInitialText;
      }
      return this.pickedDisplayText;
    },
    relativeRangeTextSelection() {
      return [5, 10, 30].map(count => {
        return {
          count,
          momentQuery: `now${this.mathOp}${count}m`,
          text: this.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${this.futureRange ? 'next' : 'last'}Minutes`, count, {
            n: count
          })
        };
      }).concat([1, 2, 6, 12, 24].map(count => {
        return {
          count,
          momentQuery: `now${this.mathOp}${count}h`,
          text: this.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${this.futureRange ? 'next' : 'last'}Hours`, count, {
            n: count
          })
        };
      })).concat([2, 7, 14, 30].map(count => {
        return {
          count,
          momentQuery: `now${this.mathOp}${count}d`,
          text: this.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${this.futureRange ? 'next' : 'last'}Days`, count, {
            n: count
          })
        };
      })).concat([6].map(count => {
        return {
          count,
          momentQuery: `now${this.mathOp}${count}M`,
          text: this.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${this.futureRange ? 'next' : 'last'}Months`, count, {
            n: count
          })
        };
      })).concat([1, 2, 5].map(count => {
        return {
          count,
          momentQuery: `now${this.mathOp}${count}y`,
          text: this.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${this.futureRange ? 'next' : 'last'}Years`, count, {
            n: count
          })
        };
      }));
    },
    relativeSingleTextSelection() {
      const timePrefix = this.plainDates ? 'plain' : this.futureRange ? 'in' : 'past';
      return [5, 15, 30].map(count => {
        return {
          count,
          momentQuery: `now${this.mathOp}${count}m`,
          text: this.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${timePrefix}Minutes`, count, {
            n: count
          })
        };
      }).concat([1, 2, 3, 12, 24].map(count => {
        return {
          count,
          momentQuery: `now${this.mathOp}${count}h`,
          text: this.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${timePrefix}Hours`, count, {
            n: count
          })
        };
      })).concat([2, 7, 14, 30].map(count => {
        return {
          count,
          momentQuery: `now${this.mathOp}${count}d`,
          text: this.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${timePrefix}Days`, count, {
            n: count
          })
        };
      })).concat([3, 6].map(count => {
        return {
          count,
          momentQuery: `now${this.mathOp}${count}M`,
          text: this.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${timePrefix}Months`, count, {
            n: count
          })
        };
      })).concat([1, 2, 5].map(count => {
        return {
          count,
          momentQuery: `now${this.mathOp}${count}y`,
          text: this.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${timePrefix}Years`, count, {
            n: count
          })
        };
      }));
    }
  },
  watch: {
    initialRange() {
      this.startDate = parseInt(this.from, 10) || (this.allowNull ? null : getTimeArrayFromRangeKey(this.initialRange)[0]);
      this.endDate = parseInt(this.to, 10) || (this.allowNull ? null : getTimeArrayFromRangeKey(this.initialRange)[1]);
    },
    from() {
      this.startDate = parseInt(this.from, 10) || (this.allowNull ? null : getTimeArrayFromRangeKey(this.initialRange)[0]);
    },
    to() {
      this.endDate = parseInt(this.to, 10) || (this.allowNull ? null : getTimeArrayFromRangeKey(this.initialRange)[1]);
    },
    defaultExpand() {
      this.expanded = this.defaultExpand ? 0 : [];
    }
  },
  mounted() {
    this.startDate = parseInt(this.from, 10) || null;
    this.endDate = parseInt(this.to, 10) || null;
    this.expanded = this.defaultExpand ? 0 : [];
    this.init();
  },
  methods: {
    getExpandIcon(attr) {
      return attr === 'true' ? 'fal fa-angle-up' : 'fal fa-angle-down';
    },
    init() {
      moment.locale(this.$store.state.app.language || window.navigator.userLanguage || window.navigator.language);
      if (this.startDate === null || this.endDate === null) {
        const times = getTimeArrayFromRangeKey(this.initialRange);
        this.startDate = this.startDate || (this.allowNull ? null : times[0]);
        this.endDate = this.endDate || (this.allowNull ? null : times[1]);
      }
    },
    getIsoDateStringFromUnix(unixTimestamp) {
      return moment(unixTimestamp * 1000).format('YYYY-MM-DD');
    },
    getUnixFromIsoDate(isoDateString) {
      return moment(new Date(isoDateString)).unix();
    },
    getUnixFromLocaleDate(dateLocaleString) {
      return moment(dateLocaleString, this.dateOnly ? 'll' : 'lll', this.getLocale()).unix();
    },
    getLocale() {
      return this.$store.state.app.language || window.navigator.userLanguage || window.navigator.language;
    },
    getLocaleDateFromUnix(unixTimestamp) {
      if (unixTimestamp === null) {
        return '';
      }
      return moment(unixTimestamp * 1000).locale(this.getLocale()).format(this.dateOnly ? 'll' : 'lll');
    },
    handleQuickRangeClick(rangeKey, soFar, count, text) {
      const times = getTimeArrayFromRangeKey(rangeKey, soFar);
      this.startDate = times[0];
      this.endDate = times[1];
      this.pickedDisplayText = text;
      this.handleApplyClick();
    },
    handleApplyClick() {
      this.$emit('date:picked', {
        from: this.startDate,
        to: this.isRange ? this.endDate : undefined
      });
      this.expanded = [];
      this.hideAlternateText = true;
    },
    validateInputDate(inputDate) {
      const inputTS = isNaN(inputDate) ? this.getUnixFromLocaleDate(inputDate) : inputDate;
      return moment(inputTS * 1000).isValid();
    },
    validateInputRange(startDate = this.startDate, endDate = this.endDate) {
      // ignore rangecheck if component is not working with time ranges
      if (!this.isRange) {
        return true;
      }
      const startTS = isNaN(startDate) ? this.getUnixFromLocaleDate(startDate) : startDate;
      const endTS = isNaN(endDate) ? this.getUnixFromLocaleDate(endDate) : endDate;
      return moment(startTS * 1000).isBefore(endTS * 1000);
    }
  }
};